import { __extends } from "tslib";
import { PBRMaterial as BJSPBRMaterial } from "@babylonjs/core/Materials/PBR/pbrMaterial";
import { Color3 } from "@babylonjs/core/Maths/math.color";
import { SerializationHelper } from "@babylonjs/core/Misc/decorators";
//import { Effect } from "@babylonjs/core/Materials/effect";
import { clamp, eq } from "../../utils/math";
import { Texture } from "./Texture";
//Patch PBR Material to lower SpecularAntiAliasing strength
/*const tPBRHelperFunctions = Effect.IncludesShadersStore["pbrHelperFunctions"];
if (tPBRHelperFunctions != null) {
    Effect.IncludesShadersStore["pbrHelperFunctions"] = tPBRHelperFunctions.replace("geometricAlphaGFactor*=0.75;", "geometricAlphaGFactor*=0.25;");
}*/
var PbrMaterial = /** @class */ (function (_super) {
    __extends(PbrMaterial, _super);
    function PbrMaterial(pName, pMatManager) {
        var _this = _super.call(this, pName, pMatManager.scene) || this;
        _this.mMatManger = pMatManager;
        _this.useRoughnessFromMetallicTextureAlpha = false;
        _this.useRoughnessFromMetallicTextureGreen = false;
        _this.enableSpecularAntiAliasing = true;
        _this.useLinearAlphaFresnel = true;
        _this.metallic = 1.0;
        _this.roughness = 1.0;
        _this.invertNormalMapX = true;
        _this.invertNormalMapY = true;
        _this.disableLighting = PbrMaterial.DisableLighting;
        _this.maxSimultaneousLights = 1;
        _this.environmentIntensity = PbrMaterial.DisableLighting ? 1.0 : 0.75;
        _this.imageProcessingConfiguration = pMatManager.pbrImageProcessing;
        _this.reflectionTexture = _this.mMatManger.getDefaultReflectionTexture();
        return _this;
    }
    PbrMaterial.prototype.dispose = function (pForceDisposeEffect, pForceDisposeTextures) {
        //never dispose default reflection texture
        if (this.reflectionTexture == this.mMatManger.getDefaultReflectionTexture())
            this.reflectionTexture = null;
        //dispose cloned textures
        if (!pForceDisposeTextures) {
            Texture._DisposeIfCloned(this.albedoTexture);
            Texture._DisposeIfCloned(this.ambientTexture);
            Texture._DisposeIfCloned(this.bumpTexture);
            Texture._DisposeIfCloned(this.cameraColorGradingTexture);
            Texture._DisposeIfCloned(this.emissiveTexture);
            Texture._DisposeIfCloned(this.environmentBRDFTexture);
            Texture._DisposeIfCloned(this.lightmapTexture);
            Texture._DisposeIfCloned(this.metallicTexture);
            Texture._DisposeIfCloned(this.microSurfaceTexture);
            Texture._DisposeIfCloned(this.opacityTexture);
            Texture._DisposeIfCloned(this.reflectionTexture);
            Texture._DisposeIfCloned(this.reflectivityTexture);
            Texture._DisposeIfCloned(this.refractionTexture);
        }
        _super.prototype.dispose.call(this, pForceDisposeEffect, pForceDisposeTextures);
    };
    PbrMaterial.prototype.clone = function (pName) {
        var _this = this;
        var tClone = SerializationHelper.Clone(function () {
            return (new PbrMaterial(pName, _this.mMatManger));
        }, this);
        return (tClone);
    };
    PbrMaterial.prototype.hasFallbackTextures = function () {
        if (this.albedoTexture != null && this.albedoTexture.isFallback === true)
            return (true);
        if (this.bumpTexture != null && this.bumpTexture.isFallback === true)
            return (true);
        if (this.metallicTexture != null && this.metallicTexture.isFallback === true)
            return (true);
        if (this.microSurfaceTexture != null && this.microSurfaceTexture.isFallback === true)
            return (true);
        return (false);
    };
    PbrMaterial.prototype.replaceTexture = function (pCurrent, pNew) {
        if (this.albedoTexture === pCurrent) {
            this.albedoTexture = pNew;
            this.markDirty();
        }
        if (this.bumpTexture === pCurrent) {
            this.bumpTexture = pNew;
            this.markDirty();
        }
        if (this.metallicTexture === pCurrent) {
            this.metallicTexture = pNew;
            this.markDirty();
        }
        if (this.microSurfaceTexture === pCurrent) {
            this.microSurfaceTexture = pNew;
            this.markDirty();
        }
    };
    PbrMaterial.prototype.collectTextures = function (pCallback) {
        pCallback(this.albedoTexture);
        pCallback(this.ambientTexture);
        pCallback(this.bumpTexture);
        pCallback(this.cameraColorGradingTexture);
        pCallback(this.emissiveTexture);
        pCallback(this.environmentBRDFTexture);
        pCallback(this.lightmapTexture);
        pCallback(this.metallicTexture);
        pCallback(this.microSurfaceTexture);
        pCallback(this.opacityTexture);
        pCallback(this.reflectionTexture);
        pCallback(this.reflectivityTexture);
        pCallback(this.refractionTexture);
    };
    PbrMaterial.ConvertToPbrParameters = function (pDiffuseColor, pHasDiffuseTexture, pSpecularColor, pShininess, pReflectivity, pAlpha, pOmatsType) {
        var tResult = {};
        tResult.metallic = PbrMaterial.ConvertToMetallic(pReflectivity, pAlpha, pOmatsType);
        tResult.roughness = PbrMaterial.ConvertToRoughness(pSpecularColor, pShininess, pReflectivity);
        tResult.albedo = pDiffuseColor.toLinearSpace();
        //adjust color
        if (eq(tResult.metallic, 1.0) && !pHasDiffuseTexture) {
            var tLum = PbrMaterial.ComputeLuminance(tResult.albedo);
            var tChroma = PbrMaterial.ComputeChroma(tResult.albedo);
            if (tLum < 0.75 && tChroma < 0.1)
                tResult.albedo = PbrMaterial.AdoptLuminance(tResult.albedo, 0.75);
        }
        return (tResult);
    };
    ;
    PbrMaterial.ConvertToMetallic = function (pReflectivity, pAlpha, pOmatsType) {
        if (pOmatsType != null && pOmatsType !== "common") {
            //metal
            if (pOmatsType === "metal" || pOmatsType === "metal_polished")
                return (1.0);
            //non-metal
            if (pOmatsType === "glass" || pOmatsType === "glass_translucent" || pOmatsType === "illuminant")
                return (0.0);
        }
        //common and unknown types
        if (pReflectivity >= 0.3 && eq(pAlpha, 1.0))
            return (1.0);
        return (0.0);
    };
    PbrMaterial.ConvertToRoughness = function (pSpecularColor, pShininess, pReflectivity) {
        if (eq(pShininess, 0.0))
            return (PbrMaterial.MAX_CONVERTED_ROUGHNESS);
        //calculate smoothness
        var tMinRoughness = 0;
        var tSmoothness = clamp((pShininess - 1.0) / 127.0, 0.0, 1.0);
        tSmoothness = 0.25 + 0.75 * tSmoothness;
        if (pReflectivity <= 0.01) {
            var tLum = PbrMaterial.ComputeLuminance(pSpecularColor);
            var tF = 1.0 - Math.pow(1.0 - tLum, 4.0);
            tSmoothness *= tF;
            tMinRoughness = 0.15;
        }
        //smoothness -> roughness
        var tRoughness = tMinRoughness + Math.pow(1.0 - tSmoothness, 2.0) *
            (PbrMaterial.MAX_CONVERTED_ROUGHNESS - tMinRoughness);
        return (clamp(tRoughness, 0.0, 1.0));
    };
    PbrMaterial.ComputeLuminance = function (pColor) {
        return (pColor.r * 0.2126729 + pColor.g * 0.7151522 + pColor.b * 0.0721750);
    };
    PbrMaterial.ComputeChroma = function (pColor) {
        return (Math.max(pColor.r, pColor.g, pColor.b) - Math.min(pColor.r, pColor.g, pColor.b));
    };
    PbrMaterial.AdoptLuminance = function (pColor, pLuminance) {
        var tLum = PbrMaterial.ComputeLuminance(pColor);
        if (pLuminance === tLum)
            return pColor;
        if (tLum > pLuminance) {
            //darken the color (blend with black)
            return (pColor.scale(pLuminance / tLum));
        }
        else {
            //brighten the color (blend with white)
            var tF = (pLuminance - tLum) / (1.0 - tLum);
            var tColor = pColor.scale(1.0 - tF);
            tColor.addToRef(new Color3(tF, tF, tF), tColor);
            return (tColor);
        }
    };
    PbrMaterial.DisableLighting = true;
    //// private ///////////////////////////////////////////////////////////////////////////////
    PbrMaterial.MAX_CONVERTED_ROUGHNESS = 0.7;
    return PbrMaterial;
}(BJSPBRMaterial));
export { PbrMaterial };
